// @flow
import Api from './ApiWorker';

type BackEndResponse = {
	data: any,
	success: boolean,
	message: string,
};

export type AverageGradesOptions = {
	study: string,
	city: Array<string>,
	year?: Array<string>,
};
export type ApiParseMatricultaionOptions = {
	storageFilePath: string,
};
export type ApiRequestOptions = AverageGradesOptions;
export type ApiRequest = (options?: ApiRequestOptions | ApiParseMatricultaionOptions) => Promise<BackEndResponse>;

export type TopGradesOptions = {
	study: string,
	year: string,
};
type TopApiRequestOptions = TopGradesOptions;
type TopApiRequest = (options?: TopApiRequestOptions) => Promise<BackEndResponse>;

export const authAdmin: ApiRequest = () => Api.send('/auth/admin', 'GET', {}, true);
export const authUser: ApiRequest = () => Api.send('/auth/user', 'GET');

export const getAverageGrades: ApiRequest = options => Api.send('/grades/average', 'POST', { options });
export const getTopGrades: TopApiRequest = (options: TopGradesOptions) =>
	Api.send(`/grades/top?year=${options.year}&study=${options.study}`, 'GET');
export const getCities: ApiRequest = () => Api.send('/cities', 'GET');
export const getStudies: ApiRequest = () => Api.send('/studies', 'GET');
export const getComparisonData: ApiRequest = options => Api.send('/comparison', 'POST', { options });

export const lastMatriculation: ApiRequest = () => Api.send('/last-matriculation', 'GET', {}, true);
export const parseMatriculation: ApiRequest = options => Api.send('/parse-matriculation', 'POST', options);
